import { defineStore } from 'pinia';

interface State {
  /** 是否登录 */
  isLogin: boolean;
  /** 未注册 */
  unregistered: boolean;
}

export const useAuthStore = defineStore('auth', {
  state: (): State => ({
    isLogin: false,
    unregistered: false,
  }),

  getters: {},

  actions: {},
});
